import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { WebSocketProvider } from "./contexts/WebSocketContext.jsx";
import { App } from "./ui/App.jsx";
import "./index.css";

function resolveRouterBasename() {
  const base = String(import.meta.env.BASE_URL || "/").replace(/\/+$/, "") || "/";
  if (base === "/") return "/";
  const p = window.location.pathname || "/";
  if (p === base || p.startsWith(`${base}/`)) return base;
  return "/";
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter basename={resolveRouterBasename()}>
      <WebSocketProvider>
        <App />
      </WebSocketProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

